import { ExternalRedirectRoute } from '../Routing/types';
const redirects: ExternalRedirectRoute[] = [
  {
    path: '/contact',
    externalRedirectTo: 'https://resilientapp.zendesk.com/hc/en-us/',
  },
];

export default redirects;
